import {
    GET_CONFIG_FORM,
    GET_CONFIG_FORM8,
    GET_CONFIG_FORM9,
    GET_ANTECEDENTES_CASO,
    GET_LIQUIDACION_PERDIDA,
    GET_DOCUMENTACION,
    GET_SELECT_DOCUMENTACION,
    GET_CASO_IMPLICADO,
    GET_ANTECEDENTES_LIQUIDACION,
    GET_DETALLES,
    GET_CLASIFICA_RESPUESTA,
    GET_MOTIVO,
    GET_ESTADO_ACCION,
    GET_MARCAS,
    GET_COMPANIAS,
    GET_SEGUROS,
    GET_TIPOVEHICULOS,
    GET_REQUISITOS,
    ENVIAR_REQUISITOS_SELECCIONADOS,
    OBTENER_LLAVES,
    POST_RESPUESTA_COBRO,
    POST_CARTA_COBRO,
    GET_CONFIG_FORM_IMPLICADO,
    GET_HITOS_CASO,
    GET_CONFIG_FORM33,
   
    
} from '../types';


export default function casoGeneralReducer(state = {}, action) {
    switch (action.type) {
    
        case GET_CONFIG_FORM:
            return { ...state, cfg_form:action.payload }
        case GET_CONFIG_FORM_IMPLICADO:
            return { ...state, cfg_form_implicado:action.payload }
        case GET_CONFIG_FORM8:
            return { ...state, cfg_form8 :action.payload }
        case GET_CONFIG_FORM9:
            return { ...state, cfg_form9:action.payload }
        case GET_ANTECEDENTES_CASO:
            return { ...state, antecedentesCasos:action.payload }
        case GET_LIQUIDACION_PERDIDA:
            return { ...state, liquidacionPerdida:action.payload }
        case GET_DOCUMENTACION:
            return { ...state, documentacion: action.payload }
        case GET_SELECT_DOCUMENTACION:
            return { ...state, selectDocumentacion: action.payload }
        case GET_CASO_IMPLICADO:
            return { ...state, casoImplicado: action.payload }
        case GET_ANTECEDENTES_LIQUIDACION:
            return { ...state, antecendentesLiquidacion: action.payload }
        case GET_DETALLES:
            return { ...state, detalles: action.payload }
        case GET_CLASIFICA_RESPUESTA:
            return { ...state, clasificaRespuesta: action.payload }
        case GET_CLASIFICA_RESPUESTA:
            return { ...state, clasificaRespuesta: action.payload }
        case GET_MOTIVO:
            return { ...state, motivo: action.payload }
        case GET_ESTADO_ACCION:
            return { ...state, estadoAccion: action.payload }
        case GET_TIPOVEHICULOS:
            return { ...state, vehiculos: action.payload }
        case GET_MARCAS:
            return { ...state, marcas: action.payload }
        case GET_SEGUROS:
            return { ...state, seguros: action.payload }
        case GET_COMPANIAS:
            return { ...state, companias: action.payload }
        case GET_REQUISITOS:
            return { ...state, requisitos: action.payload }
        case OBTENER_LLAVES:
            return { ...state, llaves: action.payload }
        case POST_RESPUESTA_COBRO:
            return { ...state, respuestaRecobro: action.payload }
        case POST_CARTA_COBRO:
            return { ...state, respuestaCarta: action.payload }
        case ENVIAR_REQUISITOS_SELECCIONADOS:
            return { ...state, requisitosSelecionados: action.payload }                        
        case GET_HITOS_CASO:
            return { ...state, hitosCasoR: action.payload }
        case GET_CONFIG_FORM33:
            return { ...state, cfg_form33: action.payload }
        default:
            return state
    }
}